import lazyWithRetry from '@shared/lib/lazyWithRetry';
import { useSearchParams } from 'react-router-dom';
import Loadable from '@components/Loadable/Loadable';
import DocumentsTable from '@features/documents/containers/DocumentsTable';
import { DocumentType } from '@utils/enums.ts';

const MyDocumentsPage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage'))
);
const DemandLetterCreatePage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/demand-letter/create'))
);
const DemandLetterUpdatePage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/demand-letter/update'))
);
const DemandLetterViewPage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/demand-letter/view'))
);
const DepositionSummaryCreatePage = Loadable(
  lazyWithRetry(
    () => import('@pages/MyDocumentsPage/deposition-summary/create')
  )
);
const DepositionSummaryUpdatePage = Loadable(
  lazyWithRetry(
    () => import('@pages/MyDocumentsPage/deposition-summary/update')
  )
);
const DepositionSummaryViewPage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/deposition-summary/view'))
);
const UseCaseCreatePage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/use-case/create'))
);
const UseCaseUpdatePage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/use-case/update'))
);
const UseCaseViewPage = Loadable(
  lazyWithRetry(() => import('@pages/MyDocumentsPage/use-case/view'))
);

function MyDocumentsIndexElement() {
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('use_case_group_id');

  // If we are at /my-documents/ with no groupId, the parent MyDocumentsPage
  // will redirect us to /my-documents/cases. We return null to prevent
  // an initial "All Documents" request before the redirect happens.
  if (!groupId) return null;

  return <DocumentsTable documentType="all" />;
}

const MyDocumentsChildRoutes = {
  path: 'my-documents',
  children: [
    {
      path: '',
      element: <MyDocumentsPage />,
      children: [
        { index: true, element: <MyDocumentsIndexElement /> },
        { path: 'all', element: <DocumentsTable documentType="all" /> },
        {
          path: 'demand-letter',
          element: <DocumentsTable documentType={DocumentType.DEMAND_LETTER} />,
        },
        {
          path: 'deposition-summary',
          element: (
            <DocumentsTable documentType={DocumentType.DEPOSITION_SUMMARY} />
          ),
        },
        {
          path: 'use-case',
          element: <DocumentsTable documentType={DocumentType.USE_CASE} />,
        },
        {
          path: 'cases',
          element: <DocumentsTable documentType="cases" />,
        },
      ],
    },
    {
      path: 'demand-letter/create/:template_id',
      element: <DemandLetterCreatePage />,
    },
    {
      path: 'demand-letter/update/:document_id',
      element: <DemandLetterUpdatePage />,
    },
    { path: 'demand-letter/view/:id', element: <DemandLetterViewPage /> },
    {
      path: 'deposition-summary/create/:template_id',
      element: <DepositionSummaryCreatePage />,
    },
    {
      path: 'deposition-summary/update/:deposition_id',
      element: <DepositionSummaryUpdatePage />,
    },
    {
      path: 'deposition-summary/view/:id',
      element: <DepositionSummaryViewPage />,
    },
    {
      path: 'use-case/create/:template_id',
      element: <UseCaseCreatePage />,
    },
    {
      path: 'use-case/update/:use_case_id',
      element: <UseCaseUpdatePage />,
    },
    {
      path: 'use-case/view/:id',
      element: <UseCaseViewPage />,
    },
  ],
};

export default MyDocumentsChildRoutes;
